<template>
  <div class="a">
    <van-swipe :autoplay="3000" indicator-color="white">
      <van-swipe-item :height="100" :width="100" v-for="(item, index) in banner" :key="index">
        <img @click="go(item.banner.url)" :src="item.banner.thumb_url" alt>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>
<script>
import { Dialog } from "vant";
export default {
  name: "HeaderSwiper",
  data() {
    return {};
  },
  props: ["list"],
  computed: {
    banner() {
      if (!this.list.length) {
        let a = [
          {
            banner: {
              thumb_url:
                "http://cdn11.jfbst.com/statics/banner.jpg",
              linkUrl: ""
            }
          }
        ];
        return a;
      } else {
        return this.list;
      }
    }
  },
  mounted() {},
  methods: {
    go(index) {
      if(!index) {
        return;
      }
      if(!index.includes('jfbst.com')) {
        Dialog.confirm({
          message: "您将进入第三方平台。相关服务和责任将由该第三方承担。如有问题请咨询该平台客服"
        }).then(() => {
          window.location.href = index;
        })
      } else {
        window.location.href = index;
      }
    }
  }
};
</script>
<style scoped>
.head-swiper {
  background: rgb(153, 51, 153);
}
.a {
  width: 100%;
  height: 180px;
}
.a img {
  width: 100%;
  height: 180px;
}
.van-swipe__indicators {
  /* position: relative; */
  top: 80% !important;
}
</style>
